// @flow
import React, { Component } from 'react';
import moment from 'moment';

import api from '../../../lib/api';
import makeUrl from '../../../lib/makeUrl';
import endpoints from '../../../lib/endpoints';

type Props = { data: Object };
type State = { lodgeData: Object | '' };

export default class LodgePurchaseItem extends Component<Props, State> {
  state = { lodgeData: '' };

  async componentDidMount() {
    const lodgeId = this.props.data.item_data.id;
    const { data } = await api.get(endpoints.lodge.details(lodgeId));

    this.setState({ lodgeData: data });
  }

  formatDate(date) {
    return moment(date).format('D MMM YYYY');
  }

  render() {
    const { item_data, status, booking_status } = this.props.data;
    const { name, address, id } = this.state.lodgeData;
    const { currency, total_amount, checkin_date, checkout_date } = item_data;
    const lodgeLink =
      name && id && address && makeUrl.goToLodgeFromPlace(name, id, address);

    return (
      <div className="list-row">
        <div className="item date">
          {`${this.formatDate(checkin_date)} - ${this.formatDate(checkout_date)}`}
        </div>
        <div className="item name">
          <i className="icon icon-hg-home" />{' '}
          <a href={lodgeLink}>
            {name ? name : ''}
            <span> {address ? `, ${address}` : ''}</span>
          </a>
        </div>
        <div className="item price">
          {currency} {total_amount}
        </div>
        {booking_status === 'rejected' ? (
          <div className="item message error">Lodge owner rejected your booking.</div>
        ) : (
          <div className="item message error" />
        )}
        <div className="item cta">
          <div color="outline" size="sm" className={status === 'Pending' ? 'pending' : ''}>
            {status ? status : ''}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/PurchaseList/LodgePurchaseItem.jsx